import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { spacing } from '@material-ui/system';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import clsx from "clsx";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import { CommonCss } from "../../services/CommonCss";
import { getCookie } from "../../services/Cookies";
import ImageGallery from "react-image-gallery";
import { BreadcrumbPage } from "../../shared";
import { useDispatch } from "react-redux";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import axios from "axios";
import { FormFormat } from "../../pages/account/FormFormat"
import { LOADING } from "../../action";
import { cookieKeys } from "../../services/Cookies";
const useStyles = makeStyles((theme) => ({
  mainBox: {
    boxShadow: "4px 4px 8px 1px #b9b8b8",
    height: "71vh",
  },
  gallerySlider: {
    "& .image-gallery .image-gallery-icon:hover svg": {
      color: "#1a1a31",
    },
    "& .image-gallery .image-gallery-left-nav ": {
      left: "-50px",
    },
    "& .image-gallery .image-gallery-right-nav ": {
      right: "-50px",
    },
    "& .image-gallery .image-gallery-bullets ": {
      bottom: "-40px",
    },
    "& .image-gallery .image-gallery-bullets .image-gallery-bullet": {
      boxShadow: "0 0 0 #1a1a31",
      padding: "6px",
      margin: "0 10px",
      border: "1px solid #1a1a31",
    },
    "& .image-gallery .image-gallery-bullets .image-gallery-bullet.active": {
      background: "#1a1a31",
    },
  },
}));
const images = [
  {
    original:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/img1.jpg",
    thumbnail:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/img1.jpg",
  },
  {
    original:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/img2.png",
    thumbnail:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/img2.png",
  }/*,
  {
    original:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/img1.jpg",
    thumbnail:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/img1.jpg",
  },
  */
];


/*const sliderImages = [
  {
    original:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/tot/tot1.jpg",
    thumbnail:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/tot/tot1.jpg",
  },
  {
    original:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/tot/tot2.jpg",
    thumbnail:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/tot/tot2.jpg",
  },
  {
    original:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/tot/tot3.jpg",
    thumbnail:
      process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/images/tot/tot3.jpg",
  },
];*/
export default function Home(props) {
  // ////console.log(props);
  const commonClasses = CommonCss();
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Home", url: "" }];
  const [imgUrl, setImgUrl] = React.useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (getCookie("profileImg"))
      onDownloadProfilePic(getCookie("profileImg"));
    // onDownloadProfilePic(getCookie("profileImg"));
  }, []);
  const onDownloadProfilePic = (data) => {
    // ////console.log(path)
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Account/DownloadProfilePic`;
    let filedata = JSON.stringify({ fileName: data });
    // ////console.log(formObj.picturepath );
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: " image/jpeg,image/png,image/gif"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        ////console.log(response);
        if (response.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "image/jpeg,image/png,image/gif" });
          //Build a URL from the file
          ////console.log(file)
          const fileURL = URL.createObjectURL(file);
          ////console.log(fileURL);
          setImgUrl(fileURL);
          // const userData = {profileImgPath : imgUrl}
          // cookieKeys(userData, 30 * 60);

        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };
  const assetTypes = getCookie("assetTypes").split(',');
  const assetTypeImages = [];
  assetTypes.forEach((assetType) => {
    if (assetType == "Transformers" || assetType == "Transformer") {
      assetTypeImages.push(images[0]);
    }
    else if (assetType == "Vessels" || assetType == "Vessel") {
      assetTypeImages.push(images[1]);
    }
  });

  const showBullets = (assetTypeImages.length > 1 ? true : false);
  return (
    <div className="main" spacing={3}>
      <Grid container spacing={3} >
        <Grid item xs={12}>
          <BreadcrumbPage rows={BreadcrumbList} />
        </Grid>
      </Grid>
      <Grid container spacing={3} className="Home-container">
        <Grid item xs={12} sm={12} md={6} spacing={3}>

          <Box className="homeleft" component="div" mr={2}>

            <Box className="homeavatar rounded"
              component="img"
              // style={{ borderRadius:"47%"}}
              // src={
              //   process.env.REACT_APP_CUSTOMER_PORTAL_URL +
              //   "assets/user_imgs/" +
              //   getCookie("profileImg")
              // }
              src={
                imgUrl != "" ? imgUrl : process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                  "assets/user_imgs/default_img.png"
              }
            />
          </Box>
          {/*   </Grid>
        <Grid item xs={12} sm={12} md={4}> */}

          <Box className="homeright" component="div">

            <h2 className="title">     {getCookie("name")}</h2>
            <h2 className="title">   Welcome To VPS Customer Portal</h2>
            <p> <b> {"Role :"} </b>  {getCookie("userRole")}  </p>
            <p><b>{"Access Role :"}</b>{getCookie("type")}</p>
            <p><b>{"Client Name :"}</b>{getCookie("clientName")}</p>
            {/*<p> <b> {"Company :"} </b>  {getCookie("clientName")} </p>*/}
            {/* <p> <b> {"Quick Access: "} </b> </p>  
                <Box  className="box-shadow mr-20 dashbd-icon" display="inline-block">
                <AccountCircleOutlinedIcon />
                </Box>
                <Box className="box-shadow  dashbd-icon"  display="inline-block">
                <HelpOutlineOutlinedIcon />
                </Box> */}
          </Box>
          <Box component="p" mt={3} className="redcopy">*You are looking at confidential information that belongs to VPS
            {/*and {getCookie("clientName")}.*/}</Box>


        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Box pl={3} pr={3} className={classes.gallerySlider}>
            <ImageGallery
              items={assetTypeImages}
              showFullscreenButton={false}
              showBullets={showBullets}
              showThumbnails={false}
              showPlayButton={false}
            />
          </Box>
        </Grid>

      </Grid>



    </div>
  );
}
